import { get, post, postExFile } from "@utils/httpUtil";

// 分页查询优惠券列表
export function couponPage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/coupon/page`, data, config);
}
// 优惠券适用服务列表
export function couponServiceRestrictionList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/coupon/couponServiceRestrictionList`, data, config);
}

// 优惠券适用药品列表
export function couponDeliverDrugList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  data.parentCatalogCode = data.parentCatalogCode || 1000;
  return post(`/c/pc/deliver/drug/page`, data, config);
}

// 新增优惠券
export function couponSave(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/coupon/save`, data, config);
}

// 新增优惠券-保存或更新草稿
export function couponSaveDraft(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/coupon/saveDraft`, data, config);
}

// 新增优惠券-保存或更新草稿
export function couponDraftUpdate(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/coupon/update`, data, config);
}

// 优惠券列表-删除优惠券
export function couponDeleteById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/coupon/deleteById`, data, config);
}

// 优惠券列表-关闭优惠券
export function couponCloseById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/coupon/closeById`, data, config);
}

// 优惠券列表-导出优惠券列表
export function couponListExport(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/coupon/export`, data, config);
}

// 优惠券列表-导出优惠券统计数据
export function couponFindStatisticData(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/coupon/findStatisticData`, data, config);
}

// 优惠券列表-导出优惠券统计数据列表
export function couponPageStatisticDataDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/coupon/pageStatisticDataDetail`, data, config);
}

// 优惠券列表-生成优惠券领取页面二维码
export function generateCouponQrCode(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/coupon/generateCouponQrCode`, data, config);
}
